import "./AccountHistoryView.scss";

import React from "react";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {Button, IconButton} from '@mui/material';
import {SmallLoadingIndicator} from '../common/SmallLoadingIndicator';
import {AccountActionHelper} from '../../actions/AccountActionHelper';
import {copyTextToClipboard} from '../../util/ClipboardUtil';
import {Notifier, SystemActions} from '../../actions/SystemActions';
import {dateTimeFromTicks, dateTimeToLocaleString} from "../../util/DateHelper";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {ButtonPanel} from "../common/ButtonPanel";

export const AccountHistoryView = () => {

    const accountHistory = useAppSelector(s => s.accountsState.accountHistory);

    const dispatch = useAppDispatch();

    if (!accountHistory) {
        return <div/>;
    }

    function onHideAccountsHistory() {
        dispatch(AccountActionHelper.hideAccountHistory());
    }

    const notifier: Notifier = {
        showNotification: message => dispatch(SystemActions.showNotification(message)),
        showError: error => dispatch(SystemActions.showError(error)),
    };

    const accountElts = accountHistory.map((account, i) => (
        <div key={i} className="account-version">
            <div className="category">{account.category}</div>

            <div className="account-name">{account.name}</div>

            {account.fields.map((field, j) => (
                <div key={j} className="field">
                    <span className="name">{field.name}</span>
                    <IconButton onClick={() => copyTextToClipboard(field.value, notifier)}><FileCopyIcon/></IconButton>
                    <span className="value">{field.value}</span>
                </div>
            ))}
            <div className="field">
                <span className="name">Modified Time</span>
                &nbsp;
                <span className="value timestamp">{dateTimeToLocaleString(dateTimeFromTicks(account.createTime))}</span>
            </div>

            {!account.decrypted ? <div className="decrypting-indicator"><SmallLoadingIndicator/></div> : null}
            {/* <div className="decrypting-indicator"><SmallLoadingIndicator /></div> */}
        </div>
    ));

    const buttons = <Button onClick={onHideAccountsHistory} variant="contained">Close</Button>;
    return (
        <ButtonPanel className="account-content-view"
                     buttons={buttons}>
            <div className="account-item">
                {accountElts}
            </div>
            <div className="edit-buttons">

            </div>
        </ButtonPanel>
    );
};
